import en from './strings.en';
import {firmsPlural} from 'stringsPlural';

const ru = {
    found: {
        zero: 'Найдено',
        one: 'Найдена',
        few: 'Найдено',
        many: 'Найдено',
        other: 'Найдено'
    },
    companies: firmsPlural.ru,
    noCompanies: 'Фирмы не найдены',
    moreThan: 'более',
    direction: 'по направлению {{from}}\u00A0— {{to}} за\u00A0{{period}}',
};

export default { ru, en: { ...ru, ...en} };
